import { ORDERSTATUS } from 'utils/Constants';

export const CONSULTANT_TEXT_IS_UNASSIGNED_KEY = 'Consultant_TextDisplay_isUnassigned';

export const CONSULTANT_PROJECT_ROUTES = {
  IN_PROGRESS: '/Consultant/ProjectsEnCours',
  DELAYED: '/Consultant/ProjectsEnRetard',
  VALIDATED: '/Consultant/ProjectsValides',
  DETAILS: '/Consultant/DetailsProject',
  CREATE_PROJECT: '/Consultant/CreateProject',
  TEXT_DETAILS: '/Consultant/TextDetails',
  IA_SMART: '/Consultant/IA_Smart',
  CREATE_IA_SMART_TEXT: '/Consultant/createIAsmarttext',
  TRANSLATION_IA: '/Consultant/TraductionIA',
  CREATE_TRANSLATION_IA: '/Consultant/CreateTraductionIA',
};

export const CONSULTANT_FILTER_ROUTES = {
  ALL: `${CONSULTANT_PROJECT_ROUTES.IN_PROGRESS}?filter=ALL`,
  [ORDERSTATUS.NONATTRIBUTED]: `${CONSULTANT_PROJECT_ROUTES.IN_PROGRESS}?filter=${ORDERSTATUS.NONATTRIBUTED}`,
  [ORDERSTATUS.INPROGRESS]: `${CONSULTANT_PROJECT_ROUTES.IN_PROGRESS}?filter=${ORDERSTATUS.INPROGRESS}`,
  [ORDERSTATUS.DELAYED]: CONSULTANT_PROJECT_ROUTES.DELAYED,
  [ORDERSTATUS.VALID]: CONSULTANT_PROJECT_ROUTES.VALIDATED,
};

export const storeConsultantProjectDisplayId = (projectId) => {
  if (!projectId) return;
  try {
    window.localStorage.setItem('AdminClient_ProjectDisplay_id', String(projectId));
  } catch (e) {}
};

export const storeConsultantTextDisplayId = (textId, { isUnassigned = false } = {}) => {
  if (!textId) return;
  try {
    window.localStorage.setItem('AdminClient_TextId', String(textId));
    if (isUnassigned) {
      window.localStorage.setItem(CONSULTANT_TEXT_IS_UNASSIGNED_KEY, 'true');
    } else {
      window.localStorage.removeItem(CONSULTANT_TEXT_IS_UNASSIGNED_KEY);
    }
  } catch (e) {}
};
